module.exports = __webpack_public_path__ + "static/media/mitchell-mcdermott.317e9edc.png";